module.exports = __webpack_public_path__ + "static/garantie-10-8b894a41d86575c957940439d309c012.svg";